import React from 'react';
import { X } from 'react-feather';

interface ICloseButtonProps {
  onClick: () => void;
  className: string;
  testID?: string;
}

export const CloseButton = (props: ICloseButtonProps) => {
  const { onClick, className, testID = 'modalCloseButton' } = props;

  return (
    <div className={className} data-test-id={testID}>
      <X onClick={onClick} />
    </div>
  );
};
